import { useState, useEffect } from 'react';
import { BasketHeader } from './bascketHeader/bascketHeader';
import { BasketBody } from './bascketBody/bascketBody';
import ShoppingCartService from './bascketBody/services/shopping-cart.service';
import SaveForLaterService from './bascketBody/services/save-for-later.service';
import { useErrorBoundary } from './ErrorBoundary';
import ReactDOM from 'react-dom';

const defaultBasketProps = { showBasket: true, showText: null }
const getItinialData = () => {
    return {
        items: [],
        count: 0,
        subTotalPrice: 0,
        deliveryPrice: 0,
        totalPrice: 0,
    }
}

export function Basket(basketProps) {
    const props = { ...defaultBasketProps, ...basketProps };
    const [showBody, setShowBody] = useState(false);
    const [shoppingBag, setShoppingBag] = useState(getItinialData());
    const [favorites, setFavorites] = useState(getItinialData());
    const handleError = useErrorBoundary();

    const updateCart = () => {
        return ShoppingCartService.get('')
            .then(data => {
                const { cartItems, saveForLater } = data || { cartItems: [], saveForLater: [] };
                const newCartItems = cartItems.map(item => ({
                    ...item,
                    totalPrice: item.price
                }));
    
                const newSavedItems = saveForLater.map(item => ({
                    ...item,
                    totalPrice: item.price * item.quantity
                }));
    
                const subTotalPrice = newCartItems.reduce((sum, item) => sum + item.totalPrice, 0);

                setShoppingBag({
                    items: newCartItems,
                    count: newCartItems.length,
                    subTotalPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: subTotalPrice
                });
    
                setFavorites({
                    items: newSavedItems,
                    count: newSavedItems.length,
                    subTotalPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: 0
                });
            })
            .catch(error => {
                handleError();
            });
    };
    
    useEffect(() => {
        updateCart();
    }, []);

    // @ts-ignore
    serviceBusShoppingCart.regiterHandler(addedItem => {
        updateCart();
    }, 1);

    const toggleBascket = (e, flag) => {
        if (e) e.stopPropagation();
        setShowBody(flag);

        if (flag) {
            document.body.classList.add('no-scroll');
        }
        else {
            document.body.classList.remove('no-scroll');
            const mobileCartBtn = document.getElementById('mobileCartBtn');
            mobileCartBtn.classList.remove('active');
        }
    }

    const toggleBasketShow = () => {
        setShowBody((prevShowBody) => {
            const newShowBody = !prevShowBody;
            toggleBascket(null, newShowBody);
            return newShowBody;
        });
    }

    useEffect(() => {
        window.updateBasket = async () => {
            console.log('updated')
            await updateCart()
        }

        return () => {
            delete window.updateBasket;
        }
    })

    useEffect(() => {
        window.toggleBasket = () => {
            toggleBasketShow();
        };
    
        return () => {
            delete window.toggleBasket;
        };
    }, []);

    useEffect(() => {
        window.closeBasket = () => {
            toggleBascket(null, false);
        };
    
        return () => {
            delete window.closeBasket;
        };
    }, []);

    const actions = {
        onDeleteItem: async (item) => {
            const result = await ShoppingCartService.patch(`delete/${item.productId}/${item.productType}`)
                .catch(error => { handleError('Could not delete item from shopping cart. Please contact administrator'); });
            updateCart();
        },
        onEdit: async (item) => {
            const result = await ShoppingCartService.update('', item)
                .catch(error => { handleError('Could not edit item in shopping cart. Please contact administrator'); });
            updateCart();
        },
        onSaveForLater: async (item) => {
            await SaveForLaterService.create(`create/${item.productId}/${item.productType}`).then(_ => {
                Promise.all([updateCart()]);
            }).catch(error => { handleError('Could not save item for later in shopping cart. Please contact administrator'); });

            //const result = SaveForLaterService.create(item.fabric.id);
        },
        onAddToBag: async (item) => {
            await SaveForLaterService.delete(`delete/${item.productId}/${item.productType}`).then(_ => {
                Promise.all([updateCart()]);
            }).catch(error => { handleError('Could not add item to shopping cart. Please contact administrator'); });
        },
        onEditFavorite: async (item) => {
            //const result = await SaveForLaterService.update(item.fabric.id).catch(error => { handleError(); });
        },
        onDeleteFavoriteItem: async (item) => {
            await SaveForLaterService.delete(`delete/${item.productId}/${item.productType}`).then(_ => {
                Promise.all([updateCart()]);
            }).catch(error => { handleError('Could not delete item from shopping cart. Please contact administrator'); });
            
            await ShoppingCartService.patch(`delete/${item.productId}/${item.productType}`).then(_ => {
                Promise.all([updateCart()]);
            }).catch(error => { handleError('Could not delete item from shopping cart. Please contact administrator'); });
        }
    }

    return <>
        {props.showBasket && <BasketHeader itemsCount={shoppingBag.count} toggleBascket={toggleBascket} showText={props.showText}  />}
        <BasketBodyPortal
            showBody={showBody}
            shoppingBag={shoppingBag}
            favorites={favorites}
            toggleBascket={toggleBascket}
            actions={actions}
        />
    </>;
}

const BasketBodyPortal = ({ showBody, shoppingBag, favorites, toggleBascket, actions }) => {
    if (!showBody) return null;

    const container = document.getElementById('shopping-cart-container');
    if (!container) return null;

    return ReactDOM.createPortal(
        <BasketBody
            shoppingBag={shoppingBag}
            favorites={favorites}
            toggleBascket={toggleBascket}
            actions={actions}
        />,
        container
    );
};